import React, { useState } from "react";
import { useSelector } from "react-redux";
import PointMissionPopupGreen1 from "../assets/images/scanpoint/Popup-green-1.webp";
import PointMissionPopupGreen2 from "../assets/images/scanpoint/Popup-green-2.webp";
import PointMissionPopupPink1 from "../assets/images/scanpoint/Popup-pink-1.webp";
import PointMissionPopupPink2 from "../assets/images/scanpoint/Popup-pink-2.webp";

const HowToPopup = ({ onClose }) => {
  const [step, setStep] = useState(1);

  const stateProfile = useSelector((state) => state.profile?.dataUser) || {};

  // let defaultTheme = "green";
  // if (stateProfile.themeSelected) {
  //   if (stateProfile.themeSelected == "1") {
  //     defaultTheme = "green";
  //   } else if (stateProfile.themeSelected == "2") {
  //     defaultTheme = "pink";
  //   }
  // }
  const theme = "green";

  const imgStep1 =
    theme === "pink" ? PointMissionPopupPink1 : PointMissionPopupGreen1;
  const imgStep2 =
    theme === "pink" ? PointMissionPopupPink2 : PointMissionPopupGreen2;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div style={{ position: "relative", width: "90%", maxWidth: "400px" }}>
        {/* ปุ่มปิด X (มุมขวาบน) */}
        <div
          onClick={onClose}
          style={{
            position: "absolute",
            top: "-2%",
            right: "-2%",
            width: "15%",
            height: "10%",
            cursor: "pointer",
            zIndex: 10,
          }}
        ></div>

        {step === 1 && (
          <>
            <img
              src={imgStep1}
              alt="How to play step 1"
              style={{ width: "100%", display: "block" }}
            />
            {/* ปุ่มต่อไป (ด้านล่างขวา) */}
            <div
              onClick={() => setStep(2)}
              style={{
                position: "absolute",
                bottom: "5%",
                right: "10%",
                width: "35%",
                height: "10%",
                cursor: "pointer",
                zIndex: 10,
              }}
            ></div>
          </>
        )}

        {step === 2 && (
          <>
            <img
              src={imgStep2}
              alt="How to play step 2"
              style={{ width: "100%", display: "block" }}
            />
            {/* ปุ่มย้อนกลับ (ด้านล่างซ้าย) */}
            <div
              onClick={() => setStep(1)}
              style={{
                position: "absolute",
                bottom: "5%",
                left: "10%",
                width: "35%",
                height: "10%",
                cursor: "pointer",
                zIndex: 10,
              }}
            ></div>
          </>
        )}
      </div>
    </div>
  );
};

export default HowToPopup;
